import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { parseShelfSearch, writeShelfSearch } from '../../reference/model/shelf.js';
import { type ShelfNavigate, ShelfPage } from '../../reference/shelf/ShelfPage.js';

/** `/reference` (1.AB-2): the shelf of SRD creatures, spells and items. */
export const Route = createFileRoute('/reference/')({
  validateSearch: (raw: Record<string, unknown>) => writeShelfSearch(parseShelfSearch(raw)),
  component: ShelfRoute,
});

function ShelfRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const go = Route.useNavigate();
  const navigate = useCallback<ShelfNavigate>(
    (next, options) => {
      void go({ search: next, replace: options.replace });
    },
    [go],
  );
  return <ShelfPage view={parseShelfSearch(search)} navigate={navigate} />;
}
